import React from "react";

export default class About extends React.Component {
  constructor(props) {
    super(props);

    this.words = ["Hello", "Hi", "Welcome", "Hola", "Namaste"];

    this.state = {
      text: "",
      wordIndex: 0,
      isDeleting: false,
    };
  }

  componentDidMount() {
    this.typeEffect();
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  typeEffect = () => {
    const { text, wordIndex, isDeleting } = this.state;
    const currentWord = this.words[wordIndex];

    if (!isDeleting) {
      if (text.length < currentWord.length) {
        this.timeout = setTimeout(() => {
          this.setState(
            {
              text: currentWord.substring(0, text.length + 1),
            },
            this.typeEffect
          );
        }, 120);
      } else {
        this.timeout = setTimeout(() => {
          this.setState(
            {
              isDeleting: true,
            },
            this.typeEffect
          );
        }, 1800);
      }
    } else {
      if (text.length > 0) {
        this.timeout = setTimeout(() => {
          this.setState(
            {
              text: currentWord.substring(0, text.length - 1),
            },
            this.typeEffect
          );
        }, 70);
      } else {
        this.setState(
          {
            isDeleting: false,
            wordIndex: (wordIndex + 1) % this.words.length,
          },
          this.typeEffect
        );
      }
    }
  };

  render() {
    const githubUrl = "https://github.com/meetrishigupta/";
    const linkedinUrl =
      "https://www.linkedin.com/in/meetrishigupta/";

    return (
      <>
        <style>{`
          @keyframes cursorBlink {
            0%, 45% { opacity: 1; }
            50%, 95% { opacity: 0; }
            100% { opacity: 1; }
          }

          .cursor-blink {
            animation: cursorBlink 1s steps(1) infinite;
          }

          @keyframes floatY {
            0%,100% { transform: translateY(0); }
            50% { transform: translateY(-14px); }
          }

          .float-hero {
            animation: floatY 6s ease-in-out infinite;
          }

          .typing-word {
            display: inline-block;
            min-width: 170px;
            padding-bottom: 20px;
            color: white;
          }
        `}</style>

        <section id="about" className="relative overflow-hidden">
          <div className="container mx-auto px-6 sm:px-10 py-16 lg:py-18">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-8 items-center">
              {/* Left */}
              <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
                {/* Badge */}
                <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 rounded-full border border-slate-700/80 bg-slate-800/40">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                  </span>

                  <span className="font-mono text-xs tracking-widest text-slate-300 uppercase">
                    Open to new opportunities
                  </span>
                </div>

                {/* Heading */}
                <h1 className="font-mono text-3xl sm:text-4xl lg:text-5xl font-medium text-white leading-tight">
                  <span className="typing-word">
                    {this.state.text}
                  </span>

                  <span className="inline-block w-[3px] h-8 sm:h-10 bg-green-500 ml-1 align-middle cursor-blink"></span>

                  <br />

                  I'm <span className="text-green-500">Rishi.</span>
                </h1>

                {/* Subtitle */}
                <h2 className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-snug max-w-xl">
                  I build outstanding, impactful applications.
                </h2>

                {/* Description */}
                <p className="mt-6 text-base sm:text-lg text-slate-400 leading-relaxed max-w-lg">
                  As a developer, I'm forever eager to explore the
                  uncharted and create marvels that leave the world in
                  awe.
                </p>

                {/* Buttons */}
                <div className="mt-10 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                  <a
                    href={githubUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2.5 h-12 px-6 rounded-lg bg-violet-600 text-white font-medium text-base shadow-lg shadow-violet-600/20 transition-all duration-200 hover:bg-violet-500 hover:shadow-violet-500/30 hover:-translate-y-0.5"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-5 h-5"
                    >
                      <path d="M12 .5C5.73.5.75 5.48.75 11.75c0 5.02 3.26 9.28 7.78 10.78.57.1.78-.25.78-.55 0-.27-.01-1-.02-1.96-3.17.69-3.83-1.53-3.83-1.53-.52-1.31-1.26-1.66-1.26-1.66-1.03-.7.08-.69.08-.69 1.14.08 1.74 1.17 1.74 1.17 1.01 1.74 2.66 1.24 3.31.95.1-.73.4-1.24.72-1.53-2.53-.29-5.19-1.27-5.19-5.63 0-1.24.44-2.26 1.17-3.06-.12-.29-.51-1.45.11-3.02 0 0 .96-.31 3.14 1.17.91-.25 1.89-.38 2.86-.38.97 0 1.95.13 2.86.38 2.18-1.48 3.14-1.17 3.14-1.17.62 1.57.23 2.73.11 3.02.73.8 1.17 1.82 1.17 3.06 0 4.37-2.67 5.34-5.21 5.62.41.36.78 1.06.78 2.15 0 1.55-.01 2.8-.01 3.18 0 .3.2.66.79.55 4.51-1.51 7.77-5.76 7.77-10.78C23.25 5.48 18.27.5 12 .5z" />
                    </svg>
                    GitHub Profile
                  </a>

                  <a
                    href={linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2.5 h-12 px-6 rounded-lg border border-slate-700 text-slate-200 font-medium text-base transition-all duration-200 hover:border-sky-500 hover:text-sky-400 hover:bg-sky-500/10 hover:-translate-y-0.5"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-5 h-5"
                    >
                      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.03-1.85-3.03-1.85 0-2.14 1.45-2.14 2.94v5.66H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.61 0 4.28 2.38 4.28 5.47v6.27zM5.34 7.43a2.07 2.07 0 1 1 0-4.13 2.07 2.07 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45z" />
                    </svg>
                    LinkedIn
                  </a>
                </div>
              </div>

              {/* Right */}
              <div className="relative flex justify-center lg:justify-end">
                <div className="absolute w-[80%] h-[80%] rounded-full bg-gradient-to-br from-green-500/20 via-violet-500/10 to-transparent blur-3xl"></div>

                <img
                  src="/images/heroimage.png"
                  alt="Rishi"
                  className="relative object-cover object-center rounded-lg w-full max-w-lg float-hero"
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}